import {Chip} from '@/components/commons/chip/Chip'
import styled, {css} from 'styled-components'

export const StyledProPhotoGrid = styled.div(
    ({theme: {mediaQueries}}) => css`
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        width: 100%;
        ${mediaQueries.l} {
            grid-template-columns: repeat(2, minmax(0, 1fr));
        }
    `
)

export const StyledTooltipText = styled.div(
    ({theme: {palette}}) => css`
        & p {
            font-weight: 500;
        }
        & span {
            color: ${palette.neutral[300]};
            font-weight: 400;
        }
    `
)
export const StyledChip = styled(Chip)(
    ({theme: {palette}}) => css`
        span {
            text-decoration-line: underline;
            text-decoration-style: dotted;
            text-decoration-color: ${palette.neutral[400]};
            text-decoration-thickness: 11%;
            text-underline-position: from-font;
        }

        & svg {
            width: 16px;
            height: 16px;
        }
    `
)

export const StyledSetCoverChip = styled(Chip)(
    ({theme: {palette}}) => css`
        cursor: pointer;
        span {
            text-decoration-line: underline;
            text-decoration-style: solid;
            text-decoration-color: ${palette.neutral[400]};
            text-decoration-thickness: 7.5%;
            text-underline-position: from-font;
        }
    `
)
